export default "__VITE_ASSET__BvGZ3z0x__"